module.exports = __webpack_public_path__ + "static/media/sykkel_red-min.5740cf82.png";